import * as types from './type';

import { Mixes }  from  '../../services/mixes';

export function getMixes(data) {
    return {
      type: types.GET_MIXES,
      payload: Mixes.getMixes(data),
    };
};